import React, { useState } from 'react'
import { useIntl } from 'react-intl'
import { Redirect } from 'react-router-dom'
import { MetaData } from 'lib/shared'
import { EmptyContainer, Spinner } from 'lib/ui'
import { CheckoutContext, CheckoutContextState } from 'lib/core/resources/context'
import { useCheckoutInit } from 'lib/modules/checkout'
import { BillingSameAsShippingHandler } from './components/BillingSameAsShippingHandler'
import { NotificationHandler } from './components/NotificationHandler'
import { Overlay } from './styled'
import { BeginCheckout } from '../../../../gtm/index'

export const CheckoutProvider: React.FC = ({ children }) => {
  const intl = useIntl()
  const [checkoutState, setCheckoutState] = useState<CheckoutContextState>({})
  const { isCartEmpty, isFailure, isLoading, isLocked } = useCheckoutInit()

  if (isCartEmpty) {
    return (
      <Redirect
        to='/cart'
      />
    )
  }

  if (isFailure) {
    return (
      <Redirect
        to='/'
      />
    )
  }

  return (
    <CheckoutContext.Provider value={{ state: checkoutState, setState: setCheckoutState }}>
      <MetaData
        title={intl.formatMessage({ id: 'checkout.title' })}
      />
      <BeginCheckout />
      <NotificationHandler />

      {!isLoading && (
        <BillingSameAsShippingHandler />
      )}

      {isLoading ? (
        <EmptyContainer>
          <Spinner />
        </EmptyContainer>
      ) : (
        children
      )}

      {isLocked && (
        <Overlay />
      )}
    </CheckoutContext.Provider>
  )
}
